import script from "./ExamHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamHistory.vue?vue&type=script&setup=true&lang=js"

import "./ExamHistory.vue?vue&type=style&index=0&id=e8a1abe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8a1abe2"]])

export default __exports__